import React from "react";

const Setting = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill" d="M14.857 2.34a15.797 15.797 0 016.506-.003 6.41 6.41 0 001.035 2.646 6.365 6.365 0 004.776 2.772 6.316 6.316 0 002.796-.422 16.002 16.002 0 013.249 5.67 6.38 6.38 0 00-1.76 2.225 6.418 6.418 0 00-.625 2.773c0 2.022.931 3.825 2.388 4.997a16.087 16.087 0 01-3.254 5.668 6.315 6.315 0 00-5.496.417 6.364 6.364 0 00-2.072 1.931 6.41 6.41 0 00-1.035 2.644c-2.145.454-4.36.456-6.506.007a6.409 6.409 0 00-1.034-2.65 6.364 6.364 0 00-4.777-2.773 6.316 6.316 0 00-2.796.424 16.003 16.003 0 01-3.249-5.673 6.381 6.381 0 001.76-2.223A6.419 6.419 0 005.388 18c0-.96-.214-1.909-.627-2.774A6.381 6.381 0 003 13.002a16.088 16.088 0 013.254-5.668 6.316 6.316 0 005.496-.417 6.366 6.366 0 002.072-1.931 6.41 6.41 0 001.035-2.644V2.34zm3.254 20.46a4.757 4.757 0 003.374-1.406 4.813 4.813 0 001.397-3.393 4.813 4.813 0 00-1.397-3.394 4.757 4.757 0 00-3.374-1.405 4.757 4.757 0 00-3.373 1.405 4.813 4.813 0 00-1.398 3.394c0 1.273.503 2.493 1.398 3.393A4.757 4.757 0 0018.11 22.8z"
          fill={fill}
      />
    </svg>
);

export default Setting;
